<script>
  /* Executable code section of the program */
  //Tools impotation
  import {
    isModalUpdate,
    indexBreakData,
    temporalBreakData,
    indexPositionData,
    temporalData,
    invitedAttendeesArray,
    customBreakId,
    alertMessagge,
    isAlertOn,
    isConfirmModalOn,
    confirmResponse,
    isReloadNecessary,
    confirmDeleteBreak,
  } from "../../apis/storage";
  import { deleteNetworkingBreak, deleteCustomElements, deleteDocument } from "../../apis/APIS";
  import ConfirmModal from "../Modals/ConfirmModal.svelte";
  //Auxiliary variables
  export let breakdCardData;
  export let indexBreakCard;
  export let indexPositionArray;
  export let user;
  $indexBreakData = indexBreakCard;

  //Display update modal
  const displayUpdateModal = () => {
    //Display modal
    $isModalUpdate = true;
    //Get break information an save in storage
    $temporalBreakData = breakdCardData;
    $indexPositionData = indexPositionArray;
    $indexBreakData = indexBreakCard;
    $invitedAttendeesArray = [];
    $customBreakId = breakdCardData.id;
  };

  //Function to display alert
  const displayAlert = () => {
    $isAlertOn = true;
  };
  //Function to display confirm modal
  const displayConfirmModal = () => {
    $isConfirmModalOn = true;
    $confirmDeleteBreak = true;
    $alertMessagge = "Are you sure you want to delete this networking break?";
  };

  //Function to delete networking break
  const deleteBreak = () => {
    let currentNetworkingBreak =
      $temporalData.networkingBreaks[indexPositionArray];
    let attendeeCustomBreak = [];
    let breakId = ""

    $confirmDeleteBreak = false;
    if ($confirmResponse) {
      $temporalData.networkingBreaks[indexPositionArray].programmedBreaks =
        currentNetworkingBreak.programmedBreaks.filter(
          (eventBreak) => eventBreak.id !== breakdCardData.id
        );
      if (breakdCardData.typeBreak !== "Regular") {
        breakdCardData.attendeesAuthorized.map((element) => {
          attendeeCustomBreak.push({
            id: element.id,
            fieldName: "customBreaks",
            values: [breakdCardData.id],
          });
        });
        


        deleteCustomElements("users", attendeeCustomBreak)
          .then(() => {
            deleteNetworkingBreak(
              "events",
              $temporalData,
              $temporalData.id,
              "Custom Break"
            ).then(() => {
              deleteDocument("breaks",breakdCardData.id)
              .then(()=>{
              $alertMessagge =
                "Networking Break has been deleted successfully.";

              $confirmDeleteBreak = false;
              $isReloadNecessary = true;
              displayAlert();
              })
            });
          })
          .catch(() => {
            $alertMessagge = "The Networking Break could not be deleted";
            $confirmDeleteBreak = false;
            $isReloadNecessary = true;
            displayAlert();
          });
      } else {
        deleteNetworkingBreak(
          "events",
          $temporalData,
          $temporalData.id,
          "Regular"
        ).then(() => {
          deleteDocument("breaks",breakdCardData.id).then(()=>{
          $alertMessagge = "Networking Break has been deleted successfully.";
          $isReloadNecessary = true;
          displayAlert();
          })
        });
      }
    }
  };
  /* End of the section */
</script>

<!-- Section to place the HTML code -->

<div class="cardContainer">
  <div class="headerCard">
    <h4>{breakdCardData.breakTittle}</h4>

    <div class="form-check form-switch">
      <input
        class="form-check-input"
        type="checkbox"
        role="switch"
        id="flexSwitchCheckChecked"
        bind:checked={breakdCardData.isVisibleBreak}
      />
      <label class="form-check-label" for="flexSwitchCheckChecked"></label>
    </div>
  </div>
  <div class="bodyCard">
    <p>
      <b>Time:</b>
      {breakdCardData.startTime}hs - {breakdCardData.endTime}hs <br />
      <b>Enable Tables:</b>
      {$temporalData.tablesNumber || "N/A"} <br />
      {#if breakdCardData.typeBreak === "Custom"}
        <b>Place:</b> {breakdCardData.placeBreak}
      {/if}
    </p>
    <p></p>
  </div>
  <div class="btnsCards">
    {#if user[0].userRole === "administrator" || user[0].userRole === "coordinator"}
      <button class="actionBtn" on:click={displayUpdateModal}
        >Edit Networking Break</button
      >
      <button class="actionBtn" on:click={() => displayConfirmModal()}
        >Delete Networking Break</button
      >
    {/if}
  </div>
</div>
{#if $confirmDeleteBreak}
  <ConfirmModal callbackFunction={deleteBreak} />
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  .cardContainer {
    width: 30%;
    background-color: white;
    margin: 10px;
    padding: 25px;
  }
  .headerCard {
    display: flex;
    justify-content: space-between;
  }
  .btnsCards {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .actionBtn {
    width: 100%;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 10px;
  }
  .actionBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .cardContainer {
      width: 40%;
      background-color: white;
      margin: 5px;
      padding: 25px;
    }
    .btnsCards {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .actionBtn {
      width: 100%;
      border-radius: 12px;
      font-size: 14px;
      font-weight: 500;
      padding: 8px 16px;
      background-color: white;
      color: #111;
      border: 1px solid #444;
      transition: all 0.3s ease-in-out;
      margin: 10px;
    }
    p {
      line-height: 1.5;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .cardContainer {
      width: 100%;
      background-color: white;
      margin: 10px 0;
      padding: 15px;
    }
    .actionBtn {
      width: 100%;
      border-radius: 10px;
      font-size: 14px;
      font-weight: 500;
      padding: 8px 16px;
      background-color: white;
      color: #111;
      border: 1px solid #444;
      transition: all 0.3s ease-in-out;
      margin: 10px;
    }
  }

  /* End of the section */
</style>
